/* eslint-disable @typescript-eslint/no-shadow */
import React from 'react';
import Button, { ButtonProps } from '@mui/material/Button';
import Dialog, { DialogProps } from '@mui/material/Dialog';
import DialogActions, { DialogActionsProps } from '@mui/material/DialogActions';
import DialogContent, { DialogContentProps } from '@mui/material/DialogContent';
import DialogContentText, { DialogContentTextProps } from '@mui/material/DialogContentText';
import DialogTitle, { DialogTitleProps } from '@mui/material/DialogTitle';
import { LinearProgress } from '@mui/material';

interface IActionProps extends ButtonProps {
  title: string;
}

interface IProps {
  open: boolean;
  onClose: () => {} | void;
  loading?: boolean;
  content?: any;
  children?: any;
  title?: string;
  actions?: IActionProps[];
  DialogProps?: DialogProps;
  DialogTitleProps?: DialogTitleProps;
  DialogContentProps?: DialogContentProps;
  DialogContentTextProps?: DialogContentTextProps;
  DialogActionsProps?: DialogActionsProps;
}

const Modal: React.FC<IProps> = ({
  open,
  onClose,
  title,
  loading,
  content,
  actions,
  DialogProps,
  DialogTitleProps,
  DialogContentProps,
  DialogContentTextProps,
  DialogActionsProps,
}) => {
  if (!open) return null;

  return (
    <Dialog
      open={open}
      onClose={onClose}
      aria-labelledby='alert-dialog-title'
      aria-describedby='alert-dialog-description'
      {...DialogProps}
    >
      {title && (
        <DialogTitle id='alert-dialog-title' {...DialogTitleProps}>
          {title}
        </DialogTitle>
      )}
      {content && (
        <DialogContent {...DialogContentProps}>
          <DialogContentText id='alert-dialog-description' {...DialogContentTextProps}>
            {content}
          </DialogContentText>
        </DialogContent>
      )}
      {loading && (
        <DialogContent {...DialogContentProps}>
          <LinearProgress />
        </DialogContent>
      )}
      {actions && (
        <DialogActions {...DialogActionsProps}>
          {actions.map(({ title: actionTitle, ...props }: IActionProps, idx: number) => (
            <Button {...props} key={idx} color='primary'>
              {actionTitle}
            </Button>
          ))}
        </DialogActions>
      )}
    </Dialog>
  );
};

export default Modal;
